import {Children, HTMLAttributes, useMemo} from 'react';
import {getValidChildren} from '../../../common/shared/utils/getValidChildren';
import {twMerge} from '../../../common/twMerge';

export interface ButtonBottomCombinationProps
  extends HTMLAttributes<HTMLDivElement> {
  direction?: 'horizontal' | 'vertical';
}

export function ButtonBottomCombination({
  direction = 'horizontal',
  children,
  className,
  ...props
}: ButtonBottomCombinationProps) {
  const {validChildren, shouldHandleMultiButton} = useMemo(() => {
    const validChildren = getValidChildren(children);
    const shouldHandleMultiButton =
      direction === 'horizontal' &&
      Children.count(getValidChildren(children)) > 2;

    return {validChildren, shouldHandleMultiButton};
  }, [children, direction]);

  return (
    <div
      className={twMerge(
        'flex items-center justify-center',
        direction === 'horizontal' && !shouldHandleMultiButton
          ? 'flex-row space-x-10pxr'
          : 'flex-col space-y-10pxr',
        className
      )}
      {...props}
    >
      {shouldHandleMultiButton ? (
        <>
          {validChildren.slice(0, -2)}
          <div className="flex flex-row w-full items-center justify-center space-x-10pxr">
            {validChildren.slice(-2)}
          </div>
        </>
      ) : (
        children
      )}
    </div>
  );
}
